// All account that has created after faceGateDate, should be gated
export const FACE_GATE_DATE = new Date('21 June 2022 00:00:00 UTC');
// All account that has created before faceGateDate, have grace time until faceGateGraceEndDate
export const FACE_GATE_GRACE_END_DATE = new Date('1 July 2023 00:00:00 UTC');
